module.exports = new __parcel__URL__("user.eb0ded5b.svg").toString();